import React, { useState } from "react";
import { motion } from "framer-motion";
import Heading from "../Typography/Heading";
import InteractiveText from "../Typography/InteractiveText";
import {
  PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
} from "../../../sections/Public/shared/publicLayoutSpec";

const PricingFAQs = () => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const faqs = [
    {
      question: "What payment methods are accepted?",
      answer:
        "Signing up is simple—create an account and then choose a plan. Trades Poster accepts major credit/debit cards and secure online payment methods. Start with the 28-day free trial before committing to a subscription.",
    },
    {
      question: "Can I upgrade my plan later?",
      answer:
        "Yes, upgrading is easy. Go to your account settings, select \"Subscription,\" and follow the prompts. Pro features like 10 featured posts, extended galleries, and priority search placement will activate immediately after the upgrade.",
    },
    {
      question: "Can I cancel or downgrade my plan?",
      answer:
        "Yes, you can cancel or switch to the Basic plan anytime via account settings. Your current plan will remain active until the end of the billing cycle, and no penalties apply.",
    },
  ];

  const toggleHandler = (index) => {
    if (activeIndex === index) {
      setActiveIndex(-1);
    } else {
      setActiveIndex(index);
    }
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1
      }
    }
  };

  return (
    <div className={`tp-container-narrow mx-auto ${PUBLIC_SECTION_GAP_CLASS}`}>
      <motion.div 
        className="w-full"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={staggerContainer}
      >
        <motion.div variants={fadeInUp} transition={{ duration: 0.6, ease: "easeOut" }}>
          <Heading variant={"h2"} className={"text-offblack"}>
            FAQs
          </Heading>
        </motion.div>
        
        <motion.div
          className={PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS}
          variants={fadeInUp}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <div className="border-t border-solid border-mediumgray"></div>
        </motion.div>

        <div className="space-y-0">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="border-b border-solid border-mediumgray"
              variants={fadeInUp}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              <div
                className="flex items-center justify-between py-6 px-4 cursor-pointer transition-colors duration-200"
                onClick={() => toggleHandler(index)}
              >
                <InteractiveText variant={"FAQHeader"} className="text-offblack font-medium">
                  {faq.question}
                </InteractiveText>
                <i
                  className={`fi ${
                    activeIndex === index ? "fi-rs-angle-up" : "fi-rs-angle-down"
                  } text-base text-offblack transition-transform duration-300 ease-in-out`}
                />
              </div>
              
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  activeIndex === index ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <div className="pb-6 px-4">
                  <InteractiveText variant={"FAQAnswer"} className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </InteractiveText>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default PricingFAQs; 